import { Link } from 'react-router-dom';
import { compact } from 'lodash-es';
import { Typography, TableList } from 'seagull';
import { routes } from "../../../constants";
import { ActiveServicesReportOptionalColumns } from "./types";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ActiveServiceRow = props => {
  const {
    visibleColumns,
    data
  } = props;
  const items = compact([{
    value: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(Typography, {
        as: Link,
        to: routes.agreement(data.relationshipId),
        "data-testid": "active-services-report-row-customer",
        variant: "paragraph1",
        noWrap: true,
        ellipsis: true,
        children: data.customerName
      }), /*#__PURE__*/_jsx(Typography, {
        "data-testid": "active-services-report-row-agreement",
        variant: "paragraph2",
        skin: "secondary",
        children: data.agreementName
      })]
    })
  }, {
    value: /*#__PURE__*/_jsx(Typography, {
      "data-testid": "active-services-report-row-service",
      variant: "paragraph1",
      noWrap: true,
      ellipsis: true,
      children: data.serviceName
    })
  }, visibleColumns[ActiveServicesReportOptionalColumns.Trigger] && {
    value: /*#__PURE__*/_jsx(Typography, {
      "data-testid": "active-services-report-row-trigger",
      variant: "paragraph1",
      noWrap: true,
      children: data.trigger
    })
  }, visibleColumns[ActiveServicesReportOptionalColumns.Pricing] && {
    value: /*#__PURE__*/_jsx(Typography, {
      "data-testid": "active-services-report-row-pricing",
      variant: "paragraph1",
      noWrap: true,
      children: data.pricing
    })
  }, visibleColumns[ActiveServicesReportOptionalColumns.Occurrence] && {
    value: /*#__PURE__*/_jsx(Typography, {
      "data-testid": "active-services-report-row-occurrence",
      variant: "paragraph1",
      noWrap: true,
      children: data.occurrence
    })
  }, visibleColumns[ActiveServicesReportOptionalColumns.Rate] && {
    value: /*#__PURE__*/_jsx(Typography, {
      "data-testid": "active-services-report-row-rate",
      variant: "paragraph1",
      noWrap: true,
      children: data.rate
    })
  }, visibleColumns[ActiveServicesReportOptionalColumns.LastBilled] && {
    value: /*#__PURE__*/_jsx(Typography, {
      "data-testid": "active-services-report-row-last-billed",
      variant: "paragraph1",
      noWrap: true,
      children: data.formattedLastBilled || '-'
    })
  }, visibleColumns[ActiveServicesReportOptionalColumns.Assignee] && {
    value: /*#__PURE__*/_jsx(Typography, {
      "data-testid": "active-services-report-row-assignee",
      variant: "paragraph1",
      noWrap: true,
      children: data.assignee
    })
  }, visibleColumns[ActiveServicesReportOptionalColumns.AutomaticServiceState] && {
    value: /*#__PURE__*/_jsx(Typography, {
      "data-testid": "active-services-report-row-paused",
      variant: "paragraph1",
      noWrap: true,
      children: data.automaticServiceState == null ? '-' : data.automaticServiceState
    })
  }, visibleColumns[ActiveServicesReportOptionalColumns.Status] && {
    value: /*#__PURE__*/_jsx(Typography, {
      "data-testid": "active-services-report-row-status",
      variant: "paragraph1",
      noWrap: true,
      children: data.status
    })
  }]);
  return /*#__PURE__*/_jsx(TableList.Row, {
    items: items,
    rowId: props.index,
    "data-testid": "active-services-report-row-".concat(props.index),
    "data-heapid": "active-services-report-row"
  });
};